import * as React from "react";
import { buildServerPackagingInstruction } from "../../Instructions";
import { CommonBuildServerPackagingTextForOctoExe, CommonBuildServerPackagingTextForIntegration, CommonTextForJavaSample } from "../CommonRegistrationText";

export const BuildServerPackaging: React.SFC<{}> = () => (
    <div>
        <p>
            When packaging Java applications from build servers, we recommend using <i>Octo.exe</i>.
        </p>
        {CommonTextForJavaSample}
        {CommonBuildServerPackagingTextForOctoExe}
        {CommonBuildServerPackagingTextForIntegration}
    </div>
);

export default buildServerPackagingInstruction(() => <BuildServerPackaging/>);